import React from 'react';
import uniqBy from 'lodash.uniqby';
import core from '@fireswan/core';

const markets = {
  '3wr': '3 Way Result',
  total_goals: 'Total Goals',
  btts: 'Both teams to score',
};

export const isEmpty = obj => Object.keys(obj).length === 0;

export const getWinRate = backtesting => {
  const wins = backtesting.bets.filter(bet => bet.result === 'win');
  const result = (wins.length / backtesting.bets.length) * 100;
  return result.toFixed(2);
};

export const getStrategyLeagues = strategy => strategy.leagues.map(league => league.name).join(', ');
export const getStrategyMarkets = strategy => {
  const {
    strategies: {pretty},
  } = core.enums;
  if (strategy.type === 'ml') {
    return uniqBy(strategy.configs, ({market}) => market)
      .map(config => markets[config.market])
      .join(', ');
  }
  return pretty[strategy.type];
};

export const getTooltipStrategyLeagues = strategy => (
  <ul>
    {strategy.leagues.map(league => (
      <li key={league.id}>{league.name}</li>
    ))}
  </ul>
);
